<template>
  <div class='code' @click='refreshCode'>
    <Sdentify :identifyCode='identifyCode'></Sdentify>
  </div>
</template>

<script>
import Sdentify from './identify'
export default {
  name: 'codetest',
  props: ['yzCode'],
  components: {
    Sdentify
  },
  data () {
    return {
      identifyCodes: '1234567890',
      identifyCode: ''
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
  },
  methods: {
    sendMsgToParents: function () {
      this.$emit('listenToChildEvent', this.identifyCodes)
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.$emit('listenToChildEvent', this.identifyCodes)
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
      console.log(this.identifyCode)
    }
  }
}
</script>

<style>
.code {
  /* margin: 400px auto; */
  width: 114px;
  height: 40px;
  border: 1px solid #fff;
  margin-left: 290px;
  margin-top: -42px;
}
</style>
